import axios from 'axios';

const API_URL = 'http://dev.ouicsport.fr/api/offer';

export const sendMessageToClub = (purchaseId, userId, message) => {
  let formData = new FormData();
  formData.append('purchaseId', purchaseId);
  formData.append('userId', userId);
  formData.append('message', message);
  
  return axios.post(`${API_URL}/message-club`, formData);
};
